module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cherry-canvas"
  }, [_c('canvas', {
    attrs: {
      "id": "mycanvas"
    }
  })])
}]}
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-3385f6fe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3385f6fe!./~/vue-loader/lib/selector.js?type=template&index=0!./src/act/march_promotion/components/cherry.vue
// module id = 292
// module chunks = 0